import { APIClient } from '@frontend/api-utils';
import { DeviceDataTemplate } from '@frontend/device/types';

export class DeviceTemplateClient extends APIClient {
    public static readonly endpoint = '/device-api/v1';

    public static async fetchDeviceDataTemplates(): Promise<DeviceDataTemplate> {
        const response = await this.fetch(`${this.endpoint}/device-data-templates`);
        return this.handleResponse<DeviceDataTemplate>(response);
    }
}
